import Repository from './Repository'
const URL_SEND_CONTACT = '/contacts'

export default {
  sendContact (payload) {
    return Repository.post(URL_SEND_CONTACT, payload)
  }
}
